export const HEADER_HEIGHT = 'space-1400';
